// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2425":"2512f7f8","6967":"5f3ca652","7329":"5f3ca652","7922":"1af7fc74","7923":"2147d047","7950":"3ba2b48a","8320":"864fbce6"}[chunkId] + ".chunk.css";
};